<template>
    <div class="header">
        <img class="app-header-img" src="./assets/logo.png" alt=" ">
<!--        <a class="app-header-icon"></a>-->
        <h1 id="app-header-title"></h1>
    </div>
</template>

<script>
  export default {
    name: "AppHeader"
  }
</script>

<style scoped>
    .header {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: row;
        padding: 1px 1px 0;
        margin-bottom: 10px;
        text-align: center;
        font-family: 'Passero One', cursive;
        color: rgba(2,56,88,0.7);
    /*rgba(0,0,0,0.7)*/

        border-bottom: 1px rgba(4,90,141,0.1) solid;
    /*rgba(0,0,0,0.1)*/
    }

    .app-header-img {
        height: 64px
    }

    #app-header-title:before {
        text-indent: 0;
        content: "Rarepi";
    }

    @media screen and (min-width: 640px) {
        #app-header-title:before {
            text-indent: 0;
            margin-left: 10px;
            content: "Random Restaurant Picker";
        }
    }
</style>